import React from 'react';
import Landing from './Landing';
import Skills from './Skills';
import Projects from './Projects';
import About from './About';
import Contact from './Contact';

const Home = () => {
  return (
    <>
        <Landing/>
        <About/>
        <Skills/>
        <Projects/>
        <Contact/>
    </>
  )
}

export default Home
